
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-background-remover",
      function () {
        return require("private-next-pages/video-background-remover/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-background-remover"])
      });
    }
  